<template>
  <div   id="main-home-proj" >

    <div id="nav-home-proj">

      <home-proj-module :lang="lang" :projId="item" v-for="(item, index) in projects" :scroll="scroll" :actScreen="actScreen" :totalScreen="totalScreen" :numScreen="(index + 1)">

      </home-proj-module>

    </div>


  </div>


</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS} from '../../main';
    import HomeProjModule from "./HomeProjModule";


    export default {

        name: 'home-proj',
      components: {HomeProjModule},
      props: ['projects', 'lang', 'isMobile'],
        data() {
            return {

              detailMain: {},
              parallaxElements:[],
              startPosX: 0,
              dragTargetX: 0,
              pastX: 0,
              scroll: 0,
              actPos: 0,
              actScreen: 1,
              totalScreen: this.projects.length,
              visited: false,
              initH: window.innerHeight


            }
        },

        created() {
        //  alert(this.isMobile)


        },
        mounted() {
          this.detailMain = document.getElementById('nav-home-proj');
          this.main = document.getElementById('main-home-proj');
            EVENTBUS.$on('control-proj-home', this.control);
            EVENTBUS.$on('incHomeProj', this.incHomeProj);
            //EVENTBUS.$emit('AAA', 0);
            //EVENTBUS.$emit('AAA', 0);


          this.initH = window.innerHeight
          setInterval(function(){
            //EVENTBUS.$emit('log', this.initH);
          });


        },

        destroyed() {
         // this.control(false);
        },

        methods: {




            control(b){

              if(b){
                //this.init();
                if(!this.visited) {
                  this.visited =  true;
                  EVENTBUS.$emit('animCase');

                }
              }else{
              //  this.removeMe();
              }


            },

            init() {

              const _this = this;



            //  document.addEventListener('keydown', _this.evtKey, false);

              $( _this.detailMain).width(_this.totalScreen * window.innerWidth)
              $('main').css('cursor', 'grab');
            },

          removeMe(){
            const _this = this;

            $('main').css('cursor', 'default');
          },





          incHomeProj(n){


              let refLat = 0 - (n * (window.innerWidth));


            //  console.log(refLat)
            EVENTBUS.$emit('handOnOff', true);
            setTimeout(function(){
              EVENTBUS.$emit('handOnOff', false);
            }, 500);

            if(!this.isMobile){
              TweenMax.to( this.detailMain, 1.2, { x:  refLat, force3D: true, ease: Power2.easeOut, onComplete:function() {

                  // EVENTBUS.$emit('wheelSwitchHome', true);

                }} );
            }else{





              let refTop = 0 - (n * 100);
              let refTopstr  = refTop + 'vh'

              TweenMax.to( this.detailMain, 1, { y:  refTopstr, force3D: true, ease: Power2.easeOut, onComplete:function() {

                  // EVENTBUS.$emit('wheelSwitchHome', true);

                }} );
            }


          },



          fullScreen(){
            const elem = document.documentElement;
            if (elem.requestFullscreen) {
              elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
              elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
              elem.msRequestFullscreen();
            }
          },

          moveContent(v) {
            const _this = this;



            if(_this.actPos >= 0)  _this.actPos = 0;




            if(_this.actPos <= (0 - (_this.detailMain.clientWidth - window.innerWidth))) _this.actPos = (0 - (_this.detailMain.clientWidth - window.innerWidth));
            TweenMax.to( _this.detailMain, 1, { x:  _this.actPos, force3D: true, ease: Power2.easeOut, onComplete:function() {

                _this.scroll = 0;
                //  _this.animModel(1);


              //  _this.getScreen();

              }} );


            // TweenMax.to($('.content-detail'), 1, { x:100, force3D:true });

           // _this.objLine = {pos: _this.actPos, w: _this.detailMain.clientWidth, screen: window.innerWidth}
          //  EVENTBUS.$emit('set-objLine', _this.objLine);

            // this.doneScreen();


            //this.moveParallax();
          },

          getScreen(){
            //console.log('_this.actPos ' + _this.actPos);

            let stopOver = [];
            let stopOverPos = [];
            let dif = [];
            let total = this.detailMain.clientWidth / window.innerWidth;
            let screenIndex = 0;

            for(let i = 0; i < total; i++){

              if(i <= 0) {
                stopOver.push(0)
                stopOverPos.push(0)
              }else{
                stopOver.push(0 - ((window.innerWidth - 50) * i));
                stopOverPos.push((window.innerWidth - 50) * i);
              }

            }

            for(let i = 0; i < total; i++){
              dif.push(Math.abs(stopOverPos[i]  + this.actPos) );
            }


            for(let i = 0; i < total; i++){
              if(Math.min.apply(Math, dif) == dif[i]){
                screenIndex = i;

              }
              //dif.push(Math.abs(stopOverPos[i]  + this.actPos) );
            }

            this.actPos = stopOver[screenIndex];
            this.moveContent(1);


          },




        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/HomeProj.vue